function SummaryItem({ label, value }) {
  return (
    <div>
      <div>
        <p className="uppercase text-[#FF9533] font-bold md:text-xs lg:text-base xl:text-xl 2xl:text-xl">
          {label}
        </p>
      </div>
      <div>
        <p className="md:text-xs lg:text-base xl:text-xl 2xl:text-xl">
          {value}
        </p>
      </div>
    </div>
  );
}
export default SummaryItem;
